export const translations = {
  en: {
    // Navigation
    nav: {
      home: 'Home',
      work: 'Work',
      services: 'Services',
      about: 'About',
      blog: 'Blog',
      more: 'More',
      quickDM: 'Quick DM',
    },
    // Hero Section
    hero: {
      title: 'Web Apps Developer',
      subtitle: 'AI Automation Specialist',
      name: 'Mauricio Guerra Navarro',
      location: 'Monterrey, México',
      description: 'Building modern web experiences with',
      techList: 'Next.js, React, and Website Builders. Landing pages, e-commerce, dashboards and tools. Marketing and digital infrastructure like',
      marketingTools: 'Kommo, GoHighLevel, Klaviyo, Metricool',
      andTheirApis: 'and their APIs.',
      specializing: 'Specializing in',
      aiWorkflows: 'AI automation workflows,',
      chatbots: 'intelligent chatbots,',
      customAgents: 'and custom agents with expertise in',
      n8n: 'n8n.',
      haru: 'Currently working with',
      copyEmail: 'Copy Email',
      copied: 'Copied!',
    },
    // About Section
    about: {
      title: 'About me',
      intro: "I'm a 20-something developer from Monterrey, México, building modern web experiences and digital infrastructure for businesses. Landing pages, e-commerce, dashboards, and tools — from design to deployment.",
      bio: "I specialize in React and Next.js development, website builders, and marketing platforms like Kommo, GoHighLevel, Klaviyo, and Metricool — including their APIs. I design and build AI automation workflows, intelligent chatbots, and custom agents using n8n. Currently working with SalesHub Agency on client projects across Latin America.",
      skillsTitle: 'Skills & Technologies',
      servicesTitle: 'Services',
      services: {
        automation: {
          title: 'Automation and Smart Workflows',
          description: 'Intelligent solutions for businesses',
        },
        webDev: {
          title: 'Web Design & Development',
          description: 'Modern, responsive web applications',
        },
        appDev: {
          title: 'App Development',
          description: 'Full-stack mobile and web applications',
        },
        seo: {
          title: 'SEO & Branding',
          description: 'Search ranking optimization and brand identity • Harü Studio',
        },
        digitalTools: {
          title: 'Digital Business Tools',
          description: 'CRMs, CMSs and ERPs, both designed or managed.',
        },
        marketingTools: {
          title: 'Marketing Tools',
          description: 'Metrics, web data analysis and automated email marketing.',
        },
      },
    },
    // Work Section
    work: {
      title: 'Featured work',
      viewProject: 'View Project',
    },
    // Quick DM
    quickDM: {
      title: 'Quick DM',
      name: 'Name',
      namePlaceholder: 'Your name',
      email: 'Email',
      emailPlaceholder: 'your@email.com',
      message: 'Message',
      messagePlaceholder: 'Your message...',
      send: 'Send Message',
      sending: 'Sending...',
      success: 'Message delivered! ✓',
    },
    // Footer
    footer: {
      rights: 'Developer Portfolio. All rights reserved.',
    },
  },
  es: {
    // Navegación
    nav: {
      home: 'Inicio',
      work: 'Trabajo',
      services: 'Servicios',
      about: 'Acerca de',
      blog: 'Blog',
      more: 'Más',
      quickDM: 'Mensaje Rápido',
    },
    // Sección Hero
    hero: {
      title: 'Desarrollador de Apps Web',
      subtitle: 'Especialista en Automatización con IA',
      name: 'Mauricio Guerra Navarro',
      location: 'Monterrey, México',
      description: 'Construyendo experiencias web modernas con',
      techList: 'Next.js, React y Website Builders. Landing pages, e-commerce, dashboards y herramientas. Marketing e infraestructura digital como',
      marketingTools: 'Kommo, GoHighLevel, Klaviyo, Metricool',
      andTheirApis: 'y sus APIs.',
      specializing: 'Especializado en',
      aiWorkflows: 'flujos de automatización con IA,',
      chatbots: 'chatbots inteligentes',
      customAgents: 'y agentes personalizados con experiencia en',
      n8n: 'n8n.',
      haru: 'Actualmente trabajando con',
      copyEmail: 'Copiar Email',
      copied: '¡Copiado!',
    },
    // Sección Acerca de
    about: {
      title: 'Acerca de mí',
      intro: 'Desarrollador de 20 y tantos años de Monterrey, México. Construyo experiencias web modernas e infraestructura digital para negocios: landing pages, e-commerce, dashboards y herramientas — del diseño al despliegue.',
      bio: 'Me especializo en React y Next.js, website builders y plataformas de marketing como Kommo, GoHighLevel, Klaviyo y Metricool, incluyendo sus APIs. Diseño y construyo flujos de automatización con IA, chatbots inteligentes y agentes personalizados usando n8n. Actualmente trabajando con SalesHub Agency en proyectos de clientes en Latinoamérica.',
      skillsTitle: 'Habilidades y Tecnologías',
      servicesTitle: 'Servicios',
      services: {
        automation: {
          title: 'Automatización y Flujos Inteligentes',
          description: 'Soluciones inteligentes para empresas',
        },
        webDev: {
          title: 'Diseño y Desarrollo Web',
          description: 'Aplicaciones web modernas y responsivas',
        },
        appDev: {
          title: 'Desarrollo de Apps',
          description: 'Aplicaciones móviles y web full-stack',
        },
        seo: {
          title: 'SEO y Branding',
          description: 'Optimización de posicionamiento y identidad de marca • Harü Studio',
        },
        digitalTools: {
          title: 'Herramientas Digitales de Negocio',
          description: 'CRMs, CMSs y ERPs, tanto diseñados como administrados.',
        },
        marketingTools: {
          title: 'Herramientas de Marketing',
          description: 'Métricas, análisis de datos web y email marketing automatizado.',
        },
      },
    },
    // Sección de Trabajo
    work: {
      title: 'Trabajo destacado',
      viewProject: 'Ver Proyecto',
    },
    // Mensaje Rápido
    quickDM: {
      title: 'Mensaje Rápido',
      name: 'Nombre',
      namePlaceholder: 'Tu nombre',
      email: 'Email',
      emailPlaceholder: 'tu@email.com',
      message: 'Mensaje',
      messagePlaceholder: 'Tu mensaje...',
      send: 'Enviar Mensaje',
      sending: 'Enviando...',
      success: '¡Mensaje enviado! ✓',
    },
    // Pie de página
    footer: {
      rights: 'Portafolio de Desarrollador. Todos los derechos reservados.',
    },
  },
  fr: {
    // Navigation
    nav: {
      home: 'Accueil',
      work: 'Travail',
      services: 'Services',
      about: 'À propos',
      blog: 'Blog',
      more: 'Plus',
      quickDM: 'Message Rapide',
    },
    // Section Hero
    hero: {
      title: 'Développeur d\'Applications Web',
      subtitle: 'Spécialiste en Automatisation IA',
      name: 'Mauricio Guerra Navarro',
      location: 'Monterrey, Mexique',
      description: 'Construire des expériences web modernes avec',
      techList: 'Next.js, React et des Website Builders. Landing pages, e-commerce, tableaux de bord et outils. Marketing et infrastructure numérique comme',
      marketingTools: 'Kommo, GoHighLevel, Klaviyo, Metricool',
      andTheirApis: 'et leurs APIs.',
      specializing: 'Spécialisé dans',
      aiWorkflows: 'les workflows d\'automatisation IA,',
      chatbots: 'chatbots intelligents',
      customAgents: 'et agents personnalisés avec expertise en',
      n8n: 'n8n.',
      haru: 'Actuellement en poste chez',
      copyEmail: 'Copier l\'Email',
      copied: 'Copié!',
    },
    // Section À propos
    about: {
      title: 'À propos de moi',
      intro: 'Développeur d\'une vingtaine d\'années de Monterrey, au Mexique. Je construis des expériences web modernes et une infrastructure numérique pour les entreprises : landing pages, e-commerce, tableaux de bord et outils — de la conception au déploiement.',
      bio: 'Je me spécialise dans React et Next.js, les website builders et les plateformes marketing comme Kommo, GoHighLevel, Klaviyo et Metricool, y compris leurs APIs. Je conçois et construis des workflows d\'automatisation IA, des chatbots intelligents et des agents personnalisés avec n8n. Actuellement en poste chez SalesHub Agency sur des projets clients en Amérique latine.',
      skillsTitle: 'Compétences et Technologies',
      servicesTitle: 'Services',
      services: {
        automation: {
          title: 'Automatisation et Flux Intelligents',
          description: 'Solutions intelligentes pour les entreprises',
        },
        webDev: {
          title: 'Conception et Développement Web',
          description: 'Applications web modernes et responsives',
        },
        appDev: {
          title: 'Développement d\'Applications',
          description: 'Applications mobiles et web full-stack',
        },
        seo: {
          title: 'SEO et Branding',
          description: 'Optimisation du référencement et identité de marque • Harü Studio',
        },
        digitalTools: {
          title: 'Outils Numériques d\'Entreprise',
          description: 'CRMs, CMSs et ERPs, conçus ou gérés.',
        },
        marketingTools: {
          title: 'Outils Marketing',
          description: 'Métriques, analyse de données web et email marketing automatisé.',
        },
      },
    },
    // Section Travail
    work: {
      title: 'Travail en vedette',
      viewProject: 'Voir le Projet',
    },
    // Message Rapide
    quickDM: {
      title: 'Message Rapide',
      name: 'Nom',
      namePlaceholder: 'Votre nom',
      email: 'Email',
      emailPlaceholder: 'votre@email.com',
      message: 'Message',
      messagePlaceholder: 'Votre message...',
      send: 'Envoyer le Message',
      sending: 'Envoi...',
      success: 'Message envoyé! ✓',
    },
    // Pied de page
    footer: {
      rights: 'Portfolio de Développeur. Tous droits réservés.',
    },
  },
};
